// extracted by css-extract-rspack-plugin
export default {"content":"xJKK0P5oNQyoxoF0"};